export default {
  data() {
    return {
      searchform: {
        isSearchLoading: false,
        isSearchSuccess: false,
        isSearchErrorNoData: false,
        isSearchErrorInvalidFormData: false,
        searchErrorMessage: '',
        searchWarningMessage: '',
        searchErrorCode: '',
      },
    };
  },

  methods: {
    searchSuccess() {
      this.searchform.isSearchSuccess = true;
      this.searchLoadingDone();
    },

    searchErrorNoData() {
      this.searchform.isSearchErrorNoData = true;
      this.searchLoadingDone();
    },

    searchReset() {
      this.searchform.isSearchSuccess = false;
      this.searchform.isSearchErrorNoData = false;
      this.searchform.isSearchErrorInvalidFormData = false;
      this.searchform.searchErrorMessage = '';
      this.searchform.searchWarningMessage = '';
      this.searchform.searchErrorCode = '';
    },

    searchLoading() {
      this.searchReset();
      this.searchform.isSearchLoading = true;
    },

    searchLoadingDone() {
      this.searchform.isSearchLoading = false;
    },

    searchErrorMessage(msg) {
      this.searchform.searchErrorMessage = msg.message ? msg.message : msg;
      this.searchLoadingDone();
    },

    searchWarningMessage(msg) {
      this.searchform.searchWarningMessage = msg;
      this.searchLoadingDone();
    },

    searchErrorInvalidFormData(errorMapping) {
      this.searchform.isSearchErrorInvalidFormData = true;
      this.searchLoadingDone();

      if (errorMapping !== null) {
        // TODO pl: error mapping?
      }
    },

    setErrorCode(code) {
      this.searchform.searchErrorCode = code;
      this.searchLoadingDone();
    },
  },
};
